import {Link} from 'react-router-dom';

import {logout} from '~/modules/firebase';

export const SideMenu = (props: {onCloseDrawer: () => void}) => {
  return (
    <div className="min-h-full w-80 bg-base-200">
      <ul className="menu p-2" tabIndex={0}>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <h2 className="menu-title">Reports</h2>
          <ul>
            <li>
              <Link to="/reports/ask-stats">Ask Stats</Link>
            </li>
            <li>
              <Link to="/challenges/weekly">Weekly Challenges</Link>
            </li>
            <li>
              <Link to="/reports/question-matches-quality">
                Question Matches Quality
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to="/reward-lookup">Reward Code Lookup</Link>
        </li>
        <li>
          <h2 className="menu-title">Users</h2>
          <ul>
            <li>
              <Link to="/user-lookup">User Lookup</Link>
            </li>
            <li>
              <Link to="/user-list-lookup">User List Lookup</Link>
            </li>
          </ul>
        </li>

        <li>
          <Link to="/polls">Polls</Link>
        </li>
        <li>
          <h2 className="menu-title">AI Support</h2>
          <ul>
            <li>
              <Link to="/ai-support/question-sample-sets">
                Question Samples
              </Link>
            </li>
            <li>
              <Link to="/ai-support/question-auto-matches">
                Question Matches
              </Link>
            </li>
            <li>
              <Link to="/ai-support/ai-tool-traces">AI Tool Traces</Link>
            </li>
          </ul>
        </li>
        <li>
          <h2 className="menu-title">Subscriptions</h2>
          <ul>
            <li>
              <Link to="/premium-stats">Premium Stats</Link>
            </li>
            <li>
              <Link to="/subscriptions/discount-codes">Discount Codes</Link>
            </li>
            <li>
              <Link to="/subscriptions/trial-codes">
                Teen Premium Trial Codes
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <h2 className="menu-title">Parent Config</h2>
          <ul>
            <li>
              <Link to="/parent-pay/pdf-consent">Record PDF Consent</Link>
            </li>
            <li>
              <Link to="/parent-pay/reset-teen-invite">
                Reset Teen Invite (Wrong Email)
              </Link>
            </li>
            <li>
              <Link to="/parent-pay/parent-lookup">Parent Lookup</Link>
            </li>
          </ul>
        </li>
        <li>
          <h2 className="menu-title">System</h2>
          <ul>
            <li>
              <Link to="/system/health">System Health</Link>
            </li>
            <li>
              <Link to="/system/config">Manage Config</Link>
            </li>
            <li>
              <Link to="/system/migrations">Migrations</Link>
            </li>
            <li>
              <Link to="/system/extracts">Extracts</Link>
            </li>
          </ul>
        </li>
        <li>
          <button onClick={logout}>Logout</button>
        </li>
      </ul>
    </div>
  );
};
